<template>
  <div class="welcome fix" :style="{ height: clientHeight + 'px' }">
    <div class="w-list">
      <h4>礼品订单 <span class="w-list-tig">待收货{{orderState.wait4Receive || 0}}张</span></h4>
      <p><router-link to="/my/order">订单列表</router-link><span class="w-tig"></span></p> 
    </div>
    <div class="w-list">
      <h4>积分管理</h4>
      <router-link to="/my/jifen">店铺积分</router-link>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      msg: "welcom"
    };
  },
  computed: {
    ...mapGetters(["orderState","clientHeight"])
  },
  created() {
    this.$store.dispatch("ORDERSTATE");
  }
};
</script>
<style>
.welcome {
  padding: 30px 20px 20px;
  width: 1140px;
  margin: auto;
  overflow-y: auto;
}
.w-list {
  width: 47%;
  border: 1px solid #eee;
  float: left;
  margin-right: 20px;
  text-align: left;
}
.w-list h4 {
  line-height: 50px;
  background: #f8f8f8;
  border-bottom: 1px solid #eee;
  padding-left: 20px;
  font-size: 14px;
  font-weight: inherit;
  color: #666;
}
.w-list-tig {
  margin-left: 10px;
  line-height: 18px;
  border-radius: 20px;
  padding: 4px 15px;
  font-size: 12px;
  color: #ff0000;
  background-color: #f9dfdf;
}
.w-list a {
  padding: 20px 6px 20px 20px;
  display: inline-block;
  color: #666;
}
.w-tig {
  color: #ff0000;
}
.w-list a:hover {
  color: #169bd5;
}
</style>
